import { api } from '../config/api';

export const clientService = {
  // Obtener todos los clientes
  getAll: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.skip) queryParams.append('skip', params.skip);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.status) queryParams.append('status', params.status);
    if (params.contact_type) queryParams.append('contact_type', params.contact_type);
    
    const queryString = queryParams.toString();
    const endpoint = `/clients/${queryString ? `?${queryString}` : ''}`;
    return await api.get(endpoint);
  },

  // Obtener un cliente por ID
  getById: async (id, options = {}) => {
    return await api.get(`/clients/${id}/`, options);
  },

  // Crear un cliente
  create: async (clientData) => {
    return await api.post('/clients/', clientData);
  },

  // Actualizar un cliente
  update: async (id, clientData) => {
    return await api.put(`/clients/${id}/`, clientData);
  },

  // Eliminar un cliente
  delete: async (id) => {
    return await api.delete(`/clients/${id}/`);
  },
};

